import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M10 3H8', key: 'mzdi2d' }],
  ['path', { d: 'm15.007 5.008 3.987 3.986', key: '1scubj' }],
  ['path', { d: 'M20 15v4', key: 'nmhudv' }],
  [
    'path',
    {
      d: 'M21.174 6.813a2.82 2.82 0 0 0-3.986-3.987L3.842 16.175a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z',
      key: 'fs0856',
    },
  ],
  ['path', { d: 'M22 17h-4', key: '1sj068' }],
  ['path', { d: 'M4 5v4', key: '13jjxc' }],
  ['path', { d: 'M6 7H2', key: '8zbtv0' }],
  ['path', { d: 'M9 2v2', key: '165o2o' }],
];

/**
 * @component @name PencilSparkles
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgM0g4IiAvPgogIDxwYXRoIGQ9Im0xNS4wMDcgNS4wMDggMy45ODcgMy45ODYiIC8+CiAgPHBhdGggZD0iTTIwIDE1djQiIC8+CiAgPHBhdGggZD0iTTIxLjE3NCA2LjgxM2EyLjgyIDIuODIgMCAwIDAtMy45ODYtMy45ODdMMy44NDIgMTYuMTc1YTIgMiAwIDAgMC0uNS44M2wtMS4zMjEgNC4zNTJhLjUuNSAwIDAgMCAuNjIzLjYyMmw0LjM1My0xLjMyYTIgMiAwIDAgMCAuODMtLjQ5N3oiIC8+CiAgPHBhdGggZD0iTTIyIDE3aC00IiAvPgogIDxwYXRoIGQ9Ik00IDV2NCIgLz4KICA8cGF0aCBkPSJNNiA3SDIiIC8+CiAgPHBhdGggZD0iTTkgMnYyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/pencil-sparkles
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PencilSparkles = createLucideIcon('pencil-sparkles', __iconNode);

export default PencilSparkles;
